export default __webpack_public_path__ + "static/media/medical-app.8eca2f1a.png";